<div class="call-to-action-wrap lang-{{currentLang}}" [ngClass]="{'gipant-mode': giPantMode, 'henterpant-mode': henterPantMode}">

  <div class="row">
    <div class="col-xl-6 col-lg-6 col-md-12 left-col">
      <h3 class="title">
        <ng-container *ngIf="giPantMode">
          {{'CTA.GIPANT.TITLE' | translate}}
        </ng-container>
        <div *ngIf="henterPantMode" [innerHTML]="'CTA.HENTERPANT.TITLE' | translate"></div>
      </h3>

      <ng-container *ngIf="giPantMode">
        <p class="description">{{'CTA.GIPANT.DESCRIPTION' | translate}}</p>
      </ng-container>

      <ng-container *ngIf="henterPantMode">
        <p class="description" [innerHTML]="'CTA.HENTERPANT.DESCRIPTION_1' | translate"></p>
        <p class="description" [innerHTML]="'CTA.HENTERPANT.DESCRIPTION_2' | translate"></p>
      </ng-container>

      <button *ngIf="giPantMode"
              class="btn btn-primary with-icon d-none d-sm-none d-md-none d-lg-block d-xl-block d-xxl-block"
              (click)="goToPickUpForm()">
        {{'CTA.GIPANT.BUTTON' | translate}} <i class="icon icon-arrow-right"></i>
      </button>
      <button *ngIf="false"
              class="btn btn-primary-henterpant with-icon d-none d-sm-none d-md-none d-lg-block d-xl-block d-xxl-block"
              (click)="goToSignUp()">
        {{'CTA.HENTERPANT.BUTTON' | translate}}
      </button><!-- *ngIf="henterPantMode" -->
    </div>

    <div class="col-xl-6 col-lg-6 col-md-12 right-col">
      <div class="right-col-wrap"></div>
      <div class="hand-wrap">
        <div class="img"></div>
      </div>
      <button class="btn btn-primary with-icon d-block d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none"
              *ngIf="giPantMode" (click)="goToPickUpForm()">
        {{'CTA.GIPANT.BUTTON' | translate}} <i class="icon icon-arrow-right"></i>
      </button>
      <button class="btn btn-primary-henterpant with-icon d-block d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none"
              *ngIf="henterPantMode" (click)="goToSignUp()">
        {{'CTA.HENTERPANT.BUTTON' | translate}}
      </button>
    </div>
  </div>
</div>
